import React, { forwardRef, useEffect, useRef } from 'react'
import ReactPlayer from 'react-player'

const VideoPlayer = forwardRef(({ src, autoplay, onCanPlay }, ref) => {
    const playerRef = useRef(null);

    useEffect(() => {
        if (playerRef.current && (autoplay || (src && src.autoplay))) {
            playerRef.current.seekTo(0);
            playerRef.current.getInternalPlayer().play().catch(error => {
                console.error("Autoplay failed:", error);
            });
        }
    }, [src, autoplay]);

    const handleReady = () => {
        if (onCanPlay) {
            onCanPlay();
        }
    };

    return (
        <ReactPlayer 
            ref={(player) => {
                playerRef.current = player;
                if (typeof ref === 'function') {
                    ref(player);
                } else if (ref) {
                    ref.current = player;
                }
            }}
            url={src && src.url ? src.url : src} 
            controls={true} 
            width="100%" 
            height="100%"
            playing={false} // We'll control play manually
            onReady={handleReady}
        />
    )
});

export default VideoPlayer;